module.exports = __webpack_public_path__ + "static/media/agradar.adf70029.png";